module.exports = __webpack_public_path__ + "img/化橘红.5142a216.jpg";